
import React from 'react';
import { InterviewRequestResponse } from '@/services/interview/requests/types';
import InterviewRequestItem from './requests/InterviewRequestItem';
import { useRequestDeletion } from '@/hooks/interview/useRequestDeletion';

interface InterviewRequestListProps {
  interviewRequests: InterviewRequestResponse[];
  onCreateNew: () => void;
  onDeleteSuccess: (deletedId: string) => void;
  onViewRequest: (request: InterviewRequestResponse) => void;
  onArchive?: (id: string) => void;
  showUnarchive?: boolean;
}

const InterviewRequestList: React.FC<InterviewRequestListProps> = ({
  interviewRequests,
  onCreateNew,
  onDeleteSuccess,
  onViewRequest,
  onArchive,
  showUnarchive = false
}) => {
  const { startDelete } = useRequestDeletion(onDeleteSuccess);

  // Rendering interview requests list

  return (
    <div className="space-y-4">
      <div className="mb-4">
        <h3 className="text-lg font-medium mb-2">
          Dine intervjuforespørsler ({interviewRequests.length})
        </h3>
        <p className="text-sm text-gray-600">
          Klikk på "Gå til skjema" for å teste skjemaet eller kopiere lenken for å dele den.
        </p>
      </div>

      {interviewRequests.map((request) => (
        <InterviewRequestItem
          key={request.id}
          request={request}
          onView={onViewRequest}
          onDelete={startDelete}
          onArchive={onArchive}
          showUnarchive={showUnarchive}
        />
      ))}
    </div>
  );
};

export default InterviewRequestList;
